
import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment-timezone';
import { HistoryItemType } from '@/features/shipment-history/types';
import { BillingType } from '@/features/shipment/types';
import { getDisplayCarrierCode } from '@/features/common/helpers/carrier';

@Component
export default class AdditionalInfo extends Vue {
  @Prop({ required: true }) item!: HistoryItemType;

  get displayCarrierCode(): string {
    return getDisplayCarrierCode(this.item.carrierCode, this.item.selectedService || '');
  }

  get createdOn(): string {
    const date = moment.utc(this.item.shipDateTime).local();

    const zoneAbbr = moment().tz(moment.tz.guess()).format('z');

    return `${date.format('MMM D, YYYY')} / ${date.format('h:mm A')} ${zoneAbbr}`;
  }

  get billingDetails(): string {
    const billingTypeTextByType = {
      [BillingType.Prepaid]: 'Prepaid',
      [BillingType.FreightCollect]: 'Freight Collect',
      [BillingType.ThirdParty]: 'Third Party',
      [BillingType.FreeDomicile]: 'Free Domicile',
      [BillingType.DDP]: 'DDP',
    };
    const { billingType, account } = this.item.billing;

    let finalValue = billingTypeTextByType[billingType];

    if (account) {
      finalValue += ` - ${account}`;
    }

    return finalValue;
  }

  get useSecureshipText(): string {
    const { myAccount, myAccountNumber } = this.item;

    const accountText = myAccountNumber ? ` #${myAccountNumber}` : '';

    return myAccount
      ? `${this.$t('tables.no')} - ${this.displayCarrierCode}${accountText}`
      : this.$t('tables.yes') as string;
  }

  get returnOption(): string {
    const { isLabelFree, isBoxFree } = this.item;

    if (isLabelFree && isBoxFree) {
      return this.$t('history.returnInfo.returnOption.labelFreeBoxFree') as string;
    }
    if (isLabelFree) {
      return this.$t('history.returnInfo.returnOption.labelFree') as string;
    }
    return '';
  }

  get qrCodeInfo(): { code: string; expiry: string } {
    const { qrCode, qrCodeExpiryDate } = this.item;

    return {
      code: qrCode?.[0] || '',
      expiry: qrCodeExpiryDate ? moment(qrCodeExpiryDate).format('MMM D, YYYY') : '',
    };
  }
}
